import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  IconButton,
  InputAdornment,
} from '@material-ui/core';
import { AiOutlineClose } from 'react-icons/ai';
import RyffineDialogTitle from '../common/RyffineDialogTitle';
import { showErrorSnackbar } from '../../redux/actions/appActions';
import { updateTaskName } from '../../redux/actions/taskActions';
import LoadingButton from '../common/LoadingButton';
import { MAIN_UI_COLOR } from '../../config';
import { TaskEntity } from '../../core/entities';

const ChangeTaskNameDialog = ({ task, onClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [taskName, setTaskName] = useState(task.name || '');

  const handleTaskNameChange = e => {
    setTaskName(e.target.value);
  };

  const handleSave = () => {
    setLoading(true);

    dispatch(updateTaskName(task.id, taskName.trim() === '' ? null : taskName))
      .then(() => {
        onClose();
        window.location.reload();
      })
      .catch(() => showErrorSnackbar('Failed to update task name.'))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <RyffineDialogTitle onClose={onClose}>
        Update Task Name
      </RyffineDialogTitle>
      <DialogContent style={{ padding: '40px 40px 30px 40px' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs>
            <TextField
              fullWidth
              label="Task Name"
              value={taskName}
              onChange={handleTaskNameChange}
              variant="outlined"
              InputProps={{
                endAdornment: taskName && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setTaskName('')}
                      style={{ marginRight: '-5px' }}
                      edge="end"
                    >
                      <AiOutlineClose color="primary" size={20} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: 0 }}>
        <Grid
          container
          style={{
            padding: '16px 24px 16px 24px',
            background: MAIN_UI_COLOR,
          }}
        >
          <LoadingButton
            className="button save-task-name-button"
            style={{
              background: 'rgb(248, 248, 248)',
              minWidth: '110px',
            }}
            disabled={taskName === task.name}
            onClick={handleSave}
            loading={loading}
            variant="outlined"
            color="primary"
          >
            Save
          </LoadingButton>

          <Button
            style={{ marginLeft: '10px', color: '#ffffff' }}
            onClick={onClose}
            className="button"
          >
            Close
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

ChangeTaskNameDialog.propTypes = {
  task: PropTypes.oneOfType([
    PropTypes.instanceOf(TaskEntity),
    PropTypes.exact({}),
  ]).isRequired,
  name: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChangeTaskNameDialog;
